{
  "name": "sharewave-frontend",
  "version": "2.2.0+20261001",
  "copyright": "Copyright 2024-2026 Content Media",
  "license": "UNLICENSED",
  "author": "Content Media",
  "homepage": "https://sharewave.io",
  "config": {
    "theme": "default",
    "coreui_library_copyright": "Copyright 2024 creativeLabs Łukasz Holeczek",
    "coreui_library_license": "MIT",
    "coreui_library_author": "The CoreUI Team (https://github.com/orgs/coreui/people) and contributors",
    "coreui_library_short_version": "5.2",
    "coreui_library_docs_url": "https://coreui.io/angular/docs/"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve -o",
    "serve": "ng serve",
    "dev": "ng serve --host 0.0.0.0",
    "build": "ng build",
    "build:test": "ng build --configuration testing",
    "build:prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.1",
    "@angular/cdk": "^18.2.1",
    "@angular/common": "^18.2.1",
    "@angular/compiler": "^18.2.1",
    "@angular/core": "^18.2.1",
    "@angular/forms": "^18.2.1",
    "@angular/language-service": "^18.2.1",
    "@angular/platform-browser": "^18.2.1",
    "@angular/platform-browser-dynamic": "^18.2.1",
    "@angular/router": "^18.2.1",
    "@coreui/angular": "~5.2.16",
    "@coreui/chartjs": "~4.0.0",
    "@coreui/coreui": "~5.1.2",
    "@coreui/icons": "^3.0.1",
    "@coreui/icons-angular": "~5.2.16",
    "@coreui/utils": "^2.0.2",
    "@siemens/ngx-datatable": "^22.4.1",
    "echarts": "^5.5.1",
    "lodash-es": "^4.17.21",
    "luxon": "^3.7.1",
    "ngx-echarts": "^18.0.0",
    "ngx-image-cropper": "^8.0.0",
    "ngx-scrollbar": "^13.0.3",
    "quill": "^2.0.3",
    "rxjs": "~7.8.1",
    "tslib": "^2.7.0",
    "uuid": "^11.1.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.1",
    "@angular/cli": "^18.2.1",
    "@angular/compiler-cli": "^18.2.1",
    "@angular/localize": "^18.2.1",
    "@types/jasmine": "^5.1.4",
    "@types/lodash-es": "^4.17.12",
    "@types/luxon": "^3.6.2",
    "@types/node": "^20.16.1",
    "jasmine-core": "^5.2.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "typescript": "~5.5.4"
  },
  "engines": {
    "node": "^18.19.0 || ^20.9.0 || >= 22",
    "npm": ">= 9"
  },
  "allowScripts": {
    "esbuild@0.23.0": true,
    "esbuild@0.21.5": true,
    "lmdb@3.0.13": true,
    "msgpackr-extract@3.0.3": true
  }
}
